import SitePage from './SitePage';

export default SitePage;
